import { useRouter } from "next/router";
import useSWR from "swr";
import type { RequestQuoteGlobals } from "~/features/request-quote-dialog/types";
import { resolveRequestQuoteLoadState } from "~/features/request-quote-dialog/load-state";
import { isRequestQuoteModalId } from "~/features/request-quote-dialog/modal";
type RequestQuoteResponse = {
  data?: RequestQuoteGlobals | null;
  success?: boolean;
};
const fetcher = async (url: string): Promise<RequestQuoteResponse> => {
  const response = await fetch(url);
  const body = (await response.json()) as RequestQuoteResponse;
  if (!response.ok || body.success !== true) {
    throw new Error("Could not load request-quote settings.");
  }
  return body;
};

/** Load the heavy quote globals only when a quote dialog is actually requested. */
export function useRequestQuoteGlobals() {
  const router = useRouter();
  const activeModal = typeof router.query.modal === "string" ? router.query.modal : undefined;
  const shouldLoad = isRequestQuoteModalId(activeModal);
  const {
    data,
    error,
    isLoading,
    mutate
  } = useSWR<RequestQuoteResponse>(shouldLoad ? "/api/get-request-quote" : null, fetcher, {
    revalidateOnFocus: false
  });
  return {
    ...resolveRequestQuoteLoadState({
      shouldLoad,
      data: data?.data,
      error,
      isLoading
    }),
    retry: () => mutate()
  };
}